import React from 'react';
import { useAuth } from '../firebase/AuthContext';
import ServerControl from '../ServerComponent/ServerControl';


const DeveloperAPI = () => {
  const { user } = useAuth();

  return (
    <div className="flex flex-col  h-[calc(100vh)]">
      {/* Header */}
      <div className="py-4 pl-5 border-b border-gray-200 flex items-center justify-between mr-2">
        <div className="text-sm font-medium text-gray-800">Developer API</div>
        <ServerControl />
      </div>
      {/* Content */}
      <div className="flex-1 p-6 overflow-auto">
        <div className="space-y-6">

          {/* API Documentation */}
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-medium text-gray-900 mb-4">API Documentation</h2>

            <div className="mb-4">
              <h3 className="text-sm font-medium text-gray-700 mb-2">Endpoint</h3>
              <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                <code className="text-sm text-green-400 font-mono">
                  GET https://api.canopylabs.ai/tts-proxy?text=hello&topP=0.9&temperature=0.6&userId={user?.uid || 'YOUR_USER_ID'}&voice=hatsu
                </code>
              </div>
            </div>

            <div className="mb-4">
              <h3 className="text-sm font-medium text-gray-700 mb-2">Response</h3>
              <p className="text-sm text-gray-600 mb-2">
                Returns a stream of audio/wav bytes. These can be stored in a file or even directly as the source of an HTML audio element.
              </p>

            </div>

            <div className="mb-4">
              <h3 className="text-sm font-medium text-gray-700 mb-2">HTML Audio Element Example</h3>
              <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto mb-3">
                <pre className="text-sm text-blue-400 font-mono whitespace-pre">
                  {`<audio controls autoplay>
  <source src="http://34.60.140.167:5000/tts-proxy?text=hello&userId=${user?.uid || 'YOUR_USER_ID'}&voice=tara" type="audio/wav">
  Your browser does not support the audio element.
</audio>`}
                </pre>
              </div>
              <p className="text-xs text-gray-500">
                The audio element will automatically handle the streaming WAV bytes and provide playback controls.
              </p>
            </div>

          </div>

          {/* Production Deployment */}
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-medium text-gray-900 mb-4">Production Deployment</h2>
            <div className="space-y-3">
              <p className="text-gray-600">
                This is a deployment for testing purposes. To get your model deployed in production, for 200ms latency and enterprise-grade uptime please get in touch with us.
              </p>
              <p className="text-gray-600">
                We'll be able to set you up same day.
              </p>
              <div className="pt-3 border-t border-gray-100">
                <div className="space-y-1">
                  <p className="text-sm text-gray-500">
                    Email: <a href="mailto:amu@canopylabs.ai" className="text-gray-900 hover:underline font-medium">amu@canopylabs.ai</a>
                  </p>
                  <p className="text-sm text-gray-500">
                    Slack Support: amu@canopylabs.ai
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DeveloperAPI;